import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'components.myaccount.claims.handling.pickup.infos.title',
    defaultMessage: 'Heures d’ouverture',
  },
});
